import { type AxiosError } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import { AuthControllerApiFactory } from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../api'
import { useGlobalConfigContext } from '../../global-config'

const getForgotPasswordRequestMutationKey = (): string => {
  return 'useForgotPasswordRequestMutation'
}

export const useApiSwrForgotPasswordRequestMutation = (): SWRMutationResponse<
  void,
  AxiosError,
  string,
  { email: string; fcSolution: string }
> => {
  const { tenantAndEnv } = useGlobalConfigContext()

  const client = useGlooApi(AuthControllerApiFactory)

  const fetcher = async (
    _key: string,
    { arg }: { arg: { email: string; fcSolution: string } },
  ): Promise<void> => {
    const response = await client.authV3TenantResetGet({
      email: arg.email,
      fcSolution: arg.fcSolution,
      tenant: tenantAndEnv,
    })

    return response.data
  }

  return useSWRMutation(getForgotPasswordRequestMutationKey(), fetcher)
}
